import { buildService } from '@rd-web-markets/shared/dist/services/service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useCallback } from 'react';
import serviceMethods from '../service_methods';
const api = buildService('/claim_groups/{id}/engagement_team', {
  only: ['get']
});
const getEngagementTeam = claimGroupId => api.get(claimGroupId);
const useGetEngagementTeam = _ref => {
  let {
    setLoading,
    claimGroupId
  } = _ref;
  const [engagementTeam, setEngagementTeam, fetchEngagementTeam] = serviceMethods.useFetch({
    initialStateValue: null,
    callback: useCallback(async () => {
      if (claimGroupId) {
        return await getEngagementTeam(claimGroupId);
      }
    }, [claimGroupId]),
    setLoading
  });
  return [engagementTeam, setEngagementTeam, fetchEngagementTeam];
};
const engagementTeamService = {
  get: getEngagementTeam,
  useGetEngagementTeam
};
export default engagementTeamService;